<ng-container *ngIf="showCallbackForm">
  <div (click)="onOverlayClick($event)"
       class="fancybox-container fancybox-is-open fancybox-can-swipe" role="dialog" tabindex="-1"
       id="fancybox-container-6" style="transition-duration: 366ms;">
    <div class="fancybox-bg"></div>
    <div class="fancybox-inner">
      <div class="fancybox-navigation">
        <button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Previous"
                disabled="">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path>
            </svg>
          </div>
        </button>
        <button data-fancybox-next=""
                class="fancybox-button fancybox-button--arrow_right compensate-for-scrollbar"
                title="Next" disabled="">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path>
            </svg>
          </div>
        </button>
      </div>
      <div class="fancybox-stage">
        <div class="fancybox-slide fancybox-slide--html fancybox-slide--current fancybox-slide--complete">

          <!-- Контейнер для формы -->
          <div class="feedback-form new-footer-form js-modal__wrapper js-modal__wrapper--form fancybox-content"
               id="quality_question" *ngIf="!formSubmitted">
            <form (ngSubmit)="onSubmit()" [formGroup]="contactForm" class="user-form__form">
              <p class="js-modal__title js-modal__title--center">Оставить заявку</p>

              <!-- Поле Имя -->
              <label class="user-form__label">
                <span class="user-form__label-inner">Ваше имя</span>
                <div class="user-form__input-wrapper">
                  <input
                    formControlName="name"
                    placeholder="Ваше имя"
                    type="text"
                    class="input-text">
                  <div *ngIf="hasError('name', 'required') && name?.touched" class="error-messages">
                    Имя обязательно для заполнения.
                  </div>
                  <div *ngIf="hasError('name', 'minlength') && name?.touched" class="error-messages">
                    Имя должно содержать минимум 3 символа
                  </div>
                </div>
              </label>

              <!-- Поле Телефон -->
              <label class="user-form__label"><span class="user-form__label-inner">Ваш телефон</span>
                <div class="user-form__input-wrapper">
                  <input
                    formControlName="phone"
                    prefix="+7"
                    mask="(000) 000-00-00"
                    [showMaskTyped]="true"
                    placeHolderCharacter="*"
                    [dropSpecialCharacters]="false"
                    class="input-text"
                    type="text"
                  />
                  <div *ngIf="hasError('phone', 'required') && phone?.touched" class="error-messages">
                    Телефон обязателен для заполнения
                  </div>
                  <div *ngIf="hasError('phone', 'pattern') && phone?.touched" class="error-messages">
                    Некорректный формат телефона
                  </div>
                </div>
              </label>

              <!-- Поле Email -->
              <label class="user-form__label"><span class="user-form__label-inner">Ваш email</span>
                <div class="user-form__input-wrapper">
                  <input
                    formControlName="email"
                    placeholder="Ваш email"
                    type="email"
                    class="input-text">
                  <div *ngIf="hasError('email', 'required') && email?.touched" class="error-messages">
                    Email обязателен для заполнения.
                  </div>
                  <div *ngIf="hasError('email', 'email') && email?.touched" class="error-messages">
                    Некорректный формат email.
                  </div>
                </div>
              </label>

              <!-- Поле Сообщение -->
              <label class="user-form__label"><span class="user-form__label-inner">Вашe сообщение</span>
                <div class="user-form__input-wrapper">
                  <textarea
                    formControlName="message"
                    class="input-text"
                    placeholder="Вашe сообщение">
                  </textarea>
                  <div *ngIf="hasError('message', 'required') && message?.touched"
                       class="error-messages">
                    Сообщение обязательно для заполнения.
                  </div>
                  <div *ngIf="hasError('message', 'minlength') && message?.touched"
                       class="error-messages">
                    Сообщение должно содержать минимум 10 символов
                  </div>
                </div>
              </label>

              <!-- Кнопка Отправить -->
              <button class="button" data-magic-button="submit" id="848250363_submit">
                Отправить
              </button>

              <!-- Согласие на обработку данных -->
              <p class="user-form__agreement">
                Отправляя форму, вы подтверждаете своё
                <a href="/agreement" class="user-form__agreement-link" target="_blank">
                  согласие на обработку персональных данных
                </a>
              </p>
            </form>
            <button (click)="onClose()" class="fancybox-button fancybox-close-small" title="Close"></button>
          </div>

          <!-- Контейнер для сообщения об успехе -->
          <div *ngIf="formSubmitted" class="user-form__success">
            <div class="user-form__success-icon"></div>
            <div class="user-form__success-message">Спасибо за Ваше обращение!</div>
            <div class="user-form__success-submit user-form__success-submit--text">
              <div class="text--center">При необходимости мы с Вами свяжемся!</div>
            </div>
            <button (click)="onClose()" class="user-form__close-button" title="Close"></button>
          </div>

        </div>
      </div>
      <div class="fancybox-caption"></div>
    </div>
  </div>
</ng-container>
